.panel-container {
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
}

.amount-space-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.amount {
  font-weight: 500;
  font-size: 2rem;
  line-height: 2.4rem;
  color: #ffffff;

  &[data-disable='true'] {
    color: #626878;
  }
}

.panel-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 1.2rem;
}

.used-amount {
  color: #367bff;
}

.location-container {
  & > span:first-of-type {
    color: #959bab;
  }

  & > span:last-of-type {
    color: #ffffff;
  }
}
